
import navBar from './home-nav-bar/home-nav-bar.vue';
import vSiderbar from '../siderbar/siderbar.vue';
import vTags from '../tags/tags.vue';

export default {
    data () {
        return {
            tagsList: []
        };
    },
    created () {
        let that = this;

        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        that.$bus.$on('tags', msg => {
            let arr = [];

            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            that.tagsList = arr;
        });
    },
    components: {
        navBar,
        vSiderbar,
        vTags
    }
};


// WEBPACK FOOTER //
// ./src/views/common/home/home.js